import React from "react";

interface LoadingState {
  pinsLoaded: boolean;
  backgroundLoaded: boolean;
  isReady: boolean;
  isCartoucheComplete: boolean;
  error: string | null;
}

export const initialLoadingState: LoadingState = {
  pinsLoaded: false,
  backgroundLoaded: false,
  error: null,
  isReady: false,
  isCartoucheComplete: false,
};

export const LoadingContext = React.createContext<
  [LoadingState, React.Dispatch<React.SetStateAction<LoadingState>>]
>([initialLoadingState, () => {}]);
